var React = require('react');

function Tractor32px (props) {
    return React.createElement("symbol",props,[React.createElement("defs",{"key":0}),React.createElement("path",{"d":"M30.867 21.153a.998.998 0 0 1-.985.847h-1.021a4.963 4.963 0 0 1 1.021 3c0 2.757-2.234 5-4.979 5-2.746 0-4.98-2.243-4.98-5 0-1.13.39-2.162 1.022-3h-3.064c.028.332.05.664.05 1 0 .552-.445 1-.996 1a.997.997 0 0 1-.995-1c0-.315-.018-.626-.048-.933A8.949 8.949 0 0 0 6.976 14a8.85 8.85 0 0 0-5.357 1.788.992.992 0 0 1-1.394-.202 1.003 1.003 0 0 1 .201-1.4 10.836 10.836 0 0 1 3.563-1.744V1c0-.552.445-1 .996-1h9.959c.401 0 .764.243.919.616l4.748 11.441 3.296.477V10c0-1.654 1.34-3 2.988-3 .55 0 .995.448.995 1s-.445 1-.995 1a.998.998 0 0 0-.996 1v2.822l5.121.74c.264.038.501.18.659.395.158.215.224.484.183.748l-.995 6.448zM24.903 28a2.997 2.997 0 0 0 2.987-3c0-1.654-1.34-3-2.987-3a2.997 2.997 0 0 0-2.988 3c0 1.654 1.34 3 2.988 3zM14.279 2H5.91v10h12.519l-4.15-10zm5.724 11.989L20 13.988c-.02.001-.037.012-.057.012h-6.669a10.954 10.954 0 0 1 4.24 6h11.515l.71-4.603-9.736-1.408zM6.976 16c3.844 0 6.972 3.14 6.972 7s-3.128 7-6.972 7C3.133 30 .005 26.86.005 23s3.128-7 6.971-7zm0 12c2.746 0 4.98-2.243 4.98-5s-2.234-5-4.98-5c-2.745 0-4.979 2.243-4.979 5s2.234 5 4.979 5z","key":1})]);
}

Tractor32px.displayName = "Tractor32px";

Tractor32px.defaultProps = {"preserveAspectRatio":"xMidYMid","viewBox":"0 0 31.85 30"};

module.exports = Tractor32px;

Tractor32px.default = Tractor32px;



//////////////////
// WEBPACK FOOTER
// ./data/assets/sprites/32px/tractor-32px.svg
// module id = 1116
// module chunks = 0